import { configureStore } from '@reduxjs/toolkit'

import adminModeReducer from '../features/adminMode/adminModeSlice'
import authReducer from '../features/auth/authSlice'
import chatReducer from '../features/chat/chatSlice'
import editorReducer from '../features/editor/editorSlice'
import localeReducer from '../features/locale/localeSlice'
import realmReducer from '../features/realm/realmSlice'
import visualizationModeReducer from '../features/visualizationMode/visualizationModeSlice'
import {
  loadAdminModeLocalStorage,
  loadChatLocalStorage,
  loadEditorLocalStorage,
  loadRealmLocalStorage,
  loadVisualizationLocalStorage
} from './localStorage'

export const store = configureStore({
  reducer: {
    editor: editorReducer,
    chat: chatReducer,
    adminMode: adminModeReducer,
    realm: realmReducer,
    locale: localeReducer,
    auth: authReducer,
    visualizationMode: visualizationModeReducer,
  },
  preloadedState: {
    adminMode: loadAdminModeLocalStorage(),
    realm: loadRealmLocalStorage(),
    visualizationMode: loadVisualizationLocalStorage(),
    editor: loadEditorLocalStorage(),
    chat: loadChatLocalStorage()
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
